import { Message, MessageState } from "./types";

export default abstract class AbstractChattingBackend {
  abstract onChatSessionUid(callback: (arg0: string) => void): void;
  abstract onMessages(callback: (arg0: Message[]) => void): void;
  abstract publishUserMessage(test: string): void;
  abstract updateMessagesState(newState: MessageState): void;
  abstract start(): void;
  abstract stop(): void;
}